import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { taskId: String }

  toggle() {
    document.dispatchEvent(new CustomEvent("ask-user-prompt:toggle", {
      detail: { taskId: this.taskIdValue }
    }))
  }
}
